/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { JsonCompat } from '../../compat/JsonCompat';
import { Document } from '../../core/models/Document';

/**
 * Constructor.
 * @class
 * @extends Document
 * @author eric.wittmann@gmail.com
 */
export abstract class AaiDocument extends Document {
    /**
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#A2SVersionString">AsyncAPI 2.0.0 spec</a>
     */
    public asyncapi : string;

    /**
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#A2SIdString">AsyncAPI 2.0.0 spec</a>
     */
    public id : string;

    /**
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#channelsObject">AsyncAPI 2.0.0 spec</a>
     */
    public channels : any;

    /**
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#serverObject">AsyncAPI 2.0.0 spec</a>
     */
    public servers : any;

    /**
     * @see <a href="https://www.asyncapi.com/docs/specifications/2.0.0/#componentsObject">AsyncAPI 2.0.0 spec</a>
     */
    public components : AaiComponents;

    public defaultContentType : string;

    public constructor() {
        super();
        if(this.asyncapi===undefined) this.asyncapi = null;
        if(this.id===undefined) this.id = null;
        this.channels = <any>({});
        if(this.servers===undefined) this.servers = null;
        if(this.components===undefined) this.components = null;
        if(this.defaultContentType===undefined) this.defaultContentType = null;
    }

    public addServer(name : string, server : AaiServer) : AaiServer {
        if(this.servers == null) {
            this.servers = <any>({});
        }
        /* put */(this.servers[name] = server);
        return server;
    }

    public getChannels() : Array<AaiChannelItem> {
        return JsonCompat.mapToList<any>(this.channels);
    }

    public addChannelItem(item : AaiChannelItem) {
        if(this.channels == null) this.channels = <any>({});
        /* put */(this.channels[item.getName()] = item);
    }

    public createServer$java_lang_String(name : string) : AaiServer { throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); }

    public createServer$java_lang_String$java_lang_String$java_lang_String(name : string, url : string, description : string) : AaiServer { throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); }

    public createServer(name? : any, url? : any, description? : any) : any {
        if(((typeof name === 'string') || name === null) && ((typeof url === 'string') || url === null) && ((typeof description === 'string') || description === null)) {
            return <any>this.createServer$java_lang_String$java_lang_String$java_lang_String(name, url, description);
        } else if(((typeof name === 'string') || name === null) && url === undefined && description === undefined) {
            return <any>this.createServer$java_lang_String(name);
        } else throw new Error('invalid overload');
    }

    public abstract createChannelItem(name : string) : AaiChannelItem;

    public abstract createComponents() : AaiComponents;

    public getServers() : Array<AaiServer> {
        return JsonCompat.mapToList<any>(this.servers);
    }
}
AaiDocument["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiDocument";
AaiDocument["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { AaiComponents } from './AaiComponents';


import { AaiServer } from './AaiServer';


import { AaiChannelItem } from './AaiChannelItem';

